import React from 'react';
import ListPaymentMethod from '../ListPaymentMethod';

const PaymentMethod = (props) => {
	const {
		isShowPaymentMethod = false,
		paymentMethodList = [],
		setIsShowPaymentMethod = () => {},
		setIsShowBottomSheet = () => {},
	} = props;

	return (
		<>
			<div className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl h-full max-h-[60vh] overflow-y-scroll scrollbar-hide ${isShowPaymentMethod ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
				<div className='flex justify-center py-4 text-base text-gray-900 font-semibold'>Pilih Metode Pembayaran</div>
				{paymentMethodList?.map((method, index) => {
					return <ListPaymentMethod key={`paymentMethodList_${index}`} {...{ method, ...props }} />;
				})}
			</div>
			<div className='!bg-white w-full p-4 z-auto shadow-custom'>
				<button
					id='payment_methods_choose'
					className='mt-2 w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm p-3 border-0 items-center'
					onClick={() => {
						setIsShowPaymentMethod(false);
						setIsShowBottomSheet(false);
					}}>
					Pilih Pembayaran
				</button>
			</div>
		</>
	);
};

export default PaymentMethod;
